import { useSelector } from 'react-redux'
import {
  maxScreenNestingDepthSelector,
  outlineFeatureFlagSelector
} from 'apps/builder/store/selectors'

export const useIsLoopable = (childSheets, depth) => {
  const outlineFeatureFlag = useSelector(outlineFeatureFlagSelector)
  const maxScreenNestingDepth = useSelector(maxScreenNestingDepthSelector)
  
  return outlineFeatureFlag && !childSheets.length && depth < maxScreenNestingDepth
}
